module.exports = require("mware");


//////////////////
// WEBPACK FOOTER
// external "mware"
// module id = 43
// module chunks = 0